import type ExtraCostPaymentType from "@/enums/ExtraCostPaymentType";
import type { DefaultComponentProps } from "@/types/component.types";
import convertToCurrency from "@/utils/convertToCurrency";
import { type ExtraCost } from "./PriceDetails";

interface AfterStayCostsProps extends DefaultComponentProps {
    readonly afterStayCosts: ExtraCost[];
    readonly renderAsterisk: (
        paymentType: ExtraCostPaymentType
    ) => string | null;
    readonly term: string;
}

function AfterStayCosts({
    afterStayCosts,
    className,
    renderAsterisk,
    term,
    testId = "after-stay-costs",
}: AfterStayCostsProps) {
    return (
        <dl className={className} data-testid={testId}>
            <dt className="font-weight-medium" data-testid={`${testId}-term`}>
                {term}
            </dt>
            <dd data-testid={`${testId}-details`}>
                <ul>
                    {afterStayCosts.map((cost) => (
                        <li key={cost.label}>
                            {cost.label} &middot;{" "}
                            {convertToCurrency({ cents: cost.price })}
                            {cost.unit ? <> / {cost.unit}</> : null}
                            {renderAsterisk(cost.paymentType)}
                        </li>
                    ))}
                </ul>
            </dd>
        </dl>
    );
}

export default AfterStayCosts;
